import { PositionAndWindCard } from "./PositionAndWindCard";
export default PositionAndWindCard;
